<div class="modal-header">
  <h5 class="modal-title">เลือกประเภทบุคคล</h5>
</div>
<div class="modal-body py-4">
  <div class="d-flex flex-column gap-3 pb-3">
    <div class="form-check type-option" [class.selected]="selectedType() === 'individual'" (click)="setType('individual')">
      <input type="radio" id="select-individual" class="form-check-input"
             [checked]="selectedType() === 'individual'"
             (change)="setType('individual')">
      <label class="form-check-label w-100" for="select-individual">
        <span class="fw-semibold">บุคคลธรรมดา</span>
        <small class="text-muted d-block">สำหรับบุคคลทั่วไปที่ประกอบธุรกิจ</small>
      </label>
    </div>
    <div class="form-check type-option" [class.selected]="selectedType() === 'company'" (click)="setType('company')">
      <input type="radio" id="select-company" class="form-check-input"
             [checked]="selectedType() === 'company'"
             (change)="setType('company')">
      <label class="form-check-label w-100" for="select-company">
        <span class="fw-semibold">นิติบุคคล</span>
        <small class="text-muted d-block">สำหรับบริษัทที่จดทะเบียนกับกรมพัฒนาธุรกิจการค้า</small>
      </label>
    </div>
    <div class="form-check type-option" [class.selected]="selectedType() === 'cooperative'" (click)="setType('cooperative')">
      <input type="radio" id="select-cooperative" class="form-check-input"
             [checked]="selectedType() === 'cooperative'"
             (change)="setType('cooperative')">
      <label class="form-check-label w-100" for="select-cooperative">
        <span class="fw-semibold">นิติบุคคลที่ไม่ได้จดทะเบียน DBD</span>
        <small class="text-muted d-block">สำหรับ สหกรณ์, วิสาหกิจชุมชน</small>
      </label>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss()">ยกเลิก</button>
  <button type="button" class="btn btn-primary" (click)="confirm()">ถัดไป</button>
</div>
